import { Navbar, NavbarBrand } from 'reactstrap'
import TuneIcon from '@mui/icons-material/Tune';
import PrintIcon from '@mui/icons-material/Print';

type TopProps = {
  isPrint: boolean
  openWizard: () => void
  setPrint: (value: boolean) => void
}
function Top({ isPrint, setPrint, openWizard }: TopProps) {
  return (    
    <>
      <Navbar color='white' dark={false} className='d-print-none'>
        <NavbarBrand href="/">
          <img src="img/logo-final.png" alt="logo" height={24} className='d-print-none' style={{position:'relative',top:'-2px',marginRight:'.5em'}}/>
            Gurobi Installation Navigator
        </NavbarBrand>

        <div className='float-right'>
        {isPrint || <button onClick={openWizard}><TuneIcon/> Wizard</button>}
        <button className={isPrint?'active':''} onClick={() => { setPrint(!isPrint) }}><PrintIcon/> {isPrint ? 'Back' : 'Print view'}</button>
        </div>        
      </Navbar>
      <h1 className="d-none d-print-block print-title">Gurobi Installation Navigator</h1>
    </>
  )
}

export default Top